
import { computed, defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { onClickOutside } from '@vueuse/core';

export default defineComponent({
  name: 'DropdownMenu',
  props: {
    preferredUserName: {
      type: String,
      required: true,
    },
    isPortal: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click', 'close'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const menuRef = ref<HTMLElement | null>(null);

    const fillColor = computed(() => (props.isPortal ? 'white' : 'black'));

    onClickOutside(menuRef, (event) => {
      /* user-icon 또는 menu-icon 클릭은 무시 */
      if (
        event.target instanceof HTMLElement &&
        (event.target.closest('.user-icon') || event.target.closest('.menu-icon'))
      ) {
        return;
      }
      emit('close');
    });

    const handleItemClick = (value: string) => emit('click', value);

    return {
      t,
      menuRef,
      handleItemClick,
      fillColor,
    };
  },
});
